import Factory from "./factory";

export const instance = new Factory();

export default { instance };
